<template>
  <div>
    <iframe className="novidades-box" id="box-novidades" title="novidades"
            src="https://azcronos.com.br/categoria/execucao-licitacoes"/>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  name: 'Novidades',
  mounted() {
    const versaoAtual = this.loki.product.version
    localStorage.setItem('ultimaVersaoNovidade', versaoAtual)
  },
  computed:{
    ...mapState(['loki'])
  }
}
</script>

<style scoped lang="stylus">
iframe
  border 0px
  margin-left 0px
  height 1100px
  margin-top 0px
  width 100%
</style>
